import { render, staticRenderFns } from "./MaterialGroupConfigList.vue?vue&type=template&id=78850fae&scoped=true"
import script from "./MaterialGroupConfigList.vue?vue&type=script&lang=js"
export * from "./MaterialGroupConfigList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78850fae",
  null
  
)

export default component.exports